import type { Component } from "solid-js";
import { type JSX, onCleanup, onMount } from "solid-js";
import { getUserStore, setUserStore, UserContext } from "~/solidJs/entities/HeaderMain/models";
import { initSuperTokens } from "~/solidJs/shared/api/auth";
import { ConnectivityModal } from "~/solidJs/widgets/ConnectivityModalWidget";
import { createRevalidateUserOnlineInfoInterval } from "../userHelpers";

type SuperTokensProps = {
	children: JSX.Element;
};

export const SuperTokens: Component<SuperTokensProps> = (props) => {
	initSuperTokens(
		() => {
			setUserStore(null);
		},
		(userInfo) => {
			setUserStore(userInfo || null);
		}
	);
	let stopRevalidation: () => void;
	onMount(() => {
		const { start, stop } = createRevalidateUserOnlineInfoInterval({
			show: ConnectivityModal.showConnectivityModal,
			close: ConnectivityModal.closeConnectivityModal
		});
		start();
		stopRevalidation = stop;
	});

	onCleanup(() => {
		stopRevalidation?.();
	});
	return <UserContext.Provider value={getUserStore}>{props.children}</UserContext.Provider>;
};
